/**
 * Fire and Ember Particle Effect.
 */
import { ParticleSystem, Particle } from './ParticleSystem';
import { SVGObjectConfig } from '../objects/SVGObject';

export class FireEffect extends ParticleSystem {
  constructor(config: SVGObjectConfig) {
    super(config, 75);
    this.emitRate = 35;
  }

  protected createParticle(): Particle {
    const colors = ['#f59e0b', '#ef4444', '#f97316', '#fbbf24', '#ffffff'];
    return {
      x: (Math.random() - 0.5) * 30,
      y: 0,
      vx: (Math.random() - 0.5) * 40,
      vy: -60 - Math.random() * 80,
      size: 4 + Math.random() * 8,
      alpha: 0.9,
      life: 0,
      maxLife: 0.8 + Math.random() * 0.5,
      color: colors[Math.floor(Math.random() * colors.length)]
    };
  }

  protected updateParticle(p: Particle, delta: number): void {
    p.x += p.vx * delta;
    p.y += p.vy * delta;
    p.size = Math.max(0.5, p.size - delta * 6);
    p.alpha = Math.max(0, 1 - p.life / p.maxLife);
  }
}
